import { get } from 'lodash';
import type { ValidationErrors } from '@frontend/utils/validation';
import { InputTextField } from '@frontend/components/userDataManagement/InputText';

export function renderTextInput(args: {
    errors: ValidationErrors;
    fieldKey: string;
    isRequired?: boolean;
    label: string;
    maxLength?: number;
    onBlur?: (value: string | null) => void;
    onDoValidate?: () => Promise<void>;
    placeholder?: string;
    tooltipText?: string;
}) {
    const { fieldKey, isRequired, label, maxLength, onDoValidate, tooltipText, errors, placeholder, onBlur } = args;

    return (
        <InputTextField
            error={errors.get(fieldKey)}
            fieldKey={fieldKey}
            hasErrors={errors.has(fieldKey)}
            isRequired={isRequired}
            label={label}
            maxLength={maxLength}
            nullable={!isRequired}
            onBlur={onBlur}
            onDoValidate={onDoValidate}
            placeholder={get(placeholder, label)}
            tooltipText={tooltipText}
        />
    );
}
